export const organizationSetupSections = {
    ORGANIZATION_PROFILE: {
        key: 1,
        heading: {
            title: "Organization Setup",
            description:
                "Users will see your organization profile information for all active AI services published",
        },
    },
    REGION: {
        key: 2,
        heading: {
            title: "Organization Setup",
            description: "You can configure how all AI services are optimized by regions",
        },
    },
    PUBLISH_TO_BLOCKCHAIN: {
        key: 3,
        heading: {
            title: "Organization Setup",
            description: "The final step will publish your company to the blockchain",
        },
    },
};

export const progressText = [
    "Organization Profile",
    "Regional Group Configuration",
    "Publish To Blockchain",
];
